// @generated by protoc-gen-connect-es v1.3.0 with parameter "target=ts,import_extension=.js"
// @generated from file bsync.proto (package bsync, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddMuteOperationRequest, AddMuteOperationResponse, AddNotifOperationRequest, AddNotifOperationResponse, DeleteOperationsByActorAndNamespaceRequest, DeleteOperationsByActorAndNamespaceResponse, PingRequest, PingResponse, PutOperationRequest, PutOperationResponse, ScanMuteOperationsRequest, ScanMuteOperationsResponse, ScanNotifOperationsRequest, ScanNotifOperationsResponse, ScanOperationsRequest, ScanOperationsResponse } from "./bsync_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service bsync.Service
 */
export const Service = {
  typeName: "bsync.Service",
  methods: {
    /**
     * Sync
     *
     * @generated from rpc bsync.Service.AddMuteOperation
     */
    addMuteOperation: {
      name: "AddMuteOperation",
      I: AddMuteOperationRequest,
      O: AddMuteOperationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc bsync.Service.ScanMuteOperations
     */
    scanMuteOperations: {
      name: "ScanMuteOperations",
      I: ScanMuteOperationsRequest,
      O: ScanMuteOperationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc bsync.Service.AddNotifOperation
     */
    addNotifOperation: {
      name: "AddNotifOperation",
      I: AddNotifOperationRequest,
      O: AddNotifOperationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc bsync.Service.ScanNotifOperations
     */
    scanNotifOperations: {
      name: "ScanNotifOperations",
      I: ScanNotifOperationsRequest,
      O: ScanNotifOperationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc bsync.Service.PutOperation
     */
    putOperation: {
      name: "PutOperation",
      I: PutOperationRequest,
      O: PutOperationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc bsync.Service.ScanOperations
     */
    scanOperations: {
      name: "ScanOperations",
      I: ScanOperationsRequest,
      O: ScanOperationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc bsync.Service.DeleteOperationsByActorAndNamespace
     */
    deleteOperationsByActorAndNamespace: {
      name: "DeleteOperationsByActorAndNamespace",
      I: DeleteOperationsByActorAndNamespaceRequest,
      O: DeleteOperationsByActorAndNamespaceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Ping
     *
     * @generated from rpc bsync.Service.Ping
     */
    ping: {
      name: "Ping",
      I: PingRequest,
      O: PingResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

